import React from 'react';
import { Link } from 'react-router-dom';

export const Home = () => {
  return (
    <>
      <h1>Home-Page</h1>
      <ul>
        <li>
          <Link to="/login">Login</Link>
        </li>
        <li>
          <Link to="/register">Register</Link>
        </li>
        <li>
          <Link to="/maps">App</Link>
        </li>
      </ul>
    </>
  );
};
